export default __webpack_public_path__ + "static/media/star-empty.b94b5dc0.svg";